import * as React from 'react';

interface AuthenticationFooterSecondaryProps {
    linkHref: string;
    linkLabel: string;
}

export function AuthenticationFooterSecondary(props: AuthenticationFooterSecondaryProps): JSX.Element {
    return (
        <footer>
            <p>Looking to use our latest product?</p>
            <a href={props.linkHref}>{props.linkLabel}</a>
        </footer>
    );
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/authenticationCardComponents/AuthenticationFooterSecondary.tsx